// function that returns a boolean checking if an object is empty
export function isEmptyObject(obj: any) {
  if (obj === null || obj === undefined) {
    return true;
  }

  return !!Object.keys(obj).length;
}

/**
Extracts the IDs from the provided array, returning a new array containing objects with the id property.
@param array The array of numbers or objects containing the id property.
@returns A new array containing objects with the id property.
*/
export function extractIds(array: (number | { id: number })[]): { id: number }[] {
  return array.reduce((acc: { id: number }[], curr) => {
    // Checks if the current element is of type number
    if (typeof curr === 'number') {
      // If it is, adds an object with the id property to the accumulation array
      acc.push({ id: curr });
    }
    // Checks if the current element is an object and has the id property of type number
    else if (typeof curr === 'object' && typeof curr.id === 'number') {
      // If it is, adds an object with the id property to the accumulation array
      acc.push({ id: curr.id });
    }
    // Returns the updated accumulation array
    return acc;
  }, []);
}

/**
 * Extracts the IDs from the given array, returning a new array containing only the ID values.
 * @param array The array of numbers or objects containing the `id` property.
 * @returns A new array containing only the ID values.
 */
export function extractOnlyIds(array: (number | { id: number })[]): number[] {
  return array.reduce((acc: number[], curr) => {
    // Check if the current element is of type number
    if (typeof curr === 'number') {
      // If so, add the number to the accumulation array
      acc.push(curr);
    }
    // Check if the current element is an object and has the `id` property of type number
    else if (typeof curr === 'object' && typeof curr.id === 'number') {
      // If so, add the `id` value to the accumulation array
      acc.push(curr.id);
    }
    // Return the updated accumulation array
    return acc;
  }, []);
}
